export default {
  companyServices: [],
  companyLocations: [],
  companyCategories: [],
  companyServiceCategories: [],
  companyTypeDocs: [],
};
